import ListItemIcon from '@mui/material/ListItemIcon';
import { useLocation } from 'react-router-dom';

import type { INavMenu } from '@/components/layout/navbar/navbar.config';
import { StyledNavMenuLink, StyledNavMenuListItem } from './MobileNavMenuItem.styles';

interface INavMenuItem {
  menuItem: INavMenu;
  onClick?: () => void;
}

function MobileNavMenuItemV2({ menuItem, onClick }: INavMenuItem) {
  const location = useLocation();

  const isActive = location.pathname === menuItem.link;

  return (
    <StyledNavMenuListItem onClick={onClick} className={isActive ? 'active' : ''}>
      <StyledNavMenuLink to={menuItem.link}>
        <ListItemIcon
          sx={{
            color: (theme) => theme.palette.common.white,
          }}
        >
          <menuItem.icon />
        </ListItemIcon>
        {menuItem.name}
      </StyledNavMenuLink>
    </StyledNavMenuListItem>
  );
}

export default MobileNavMenuItemV2;
